import React, { useEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import TableActions from "../../../components/Common/TableActions";
import { PROMOCODE_LIST, DELETE_PROMOCODE, GET_NOTIFICATION_LIST_API, MARK_NOTIFICATION_AS_READ_API, MARK_ALL_NOTIFICATIONS_AS_READ_API } from "../../../services/ApiCalls";
import dataHandler from "../../../hooks/dataHandler";
import moment from "moment";
import Toggle from "../../../components/Common/Toggle";
import Filter from "../../../components/Common/Filter";
import {
  activeInactiveOptions,
  defaultDeleteModelState,
} from "../../../utilities/const";
import { Link } from "react-router-dom";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import CustomPagination from "../../../components/Common/CustomPagination";
import ButtonLoader from "../../../components/Common/ButtonLoader";
import Loading from "../../../components/Common/Loading";

const Notification = () => {
  const [state, setState] = useState({ tab: "all" });
  const [notificationsData, setNotificationsData] = useState([
    {
      id: 1,
      title: "New booking confirmed for Deluxe Room 101.",
      type: "booking",
      status: "unread",
      timeAgo: "5m ago",
      action: "Mark Read",
      icon: "📅",
      bgColor: "#fff0f3",
    },
    {
      id: 2,
      title: "Payment gateway connection error: Retrying batch.",
      type: "system",
      status: "unread",
      timeAgo: "1h ago",
      action: "Mark Read",
      icon: "⚠️",
      bgColor: "#fff0f3",
    },
    {
      id: 3,
      title: "Guest has checked in to Economy Room 305.",
      type: "checkin",
      status: "read",
      timeAgo: "2h ago",
      action: "Viewed",
      icon: "📅",
      bgColor: "#f4fff4",
    },
    {
      id: 4,
      title: "CHECKOUT ALERT: Room 104 due in 10 minutes (11:00).",
      type: "alert",
      status: "unread",
      timeAgo: "3h ago",
      action: "Mark Read",
      icon: "🕒",
      bgColor: "#fff7f0",
    },
    {
      id: 5,
      title: "Maintenance completed for Room 501. Status: Available.",
      type: "maintenance",
      status: "read",
      timeAgo: "1d ago",
      action: "Viewed",
      icon: "⚠️",
      bgColor: "#f4fff4",
    },
    {
      id: 6,
      title: "Guest has checked out of Deluxe Room 101.",
      type: "checkout",
      status: "read",
      timeAgo: "2d ago",
      action: "Viewed",
      icon: "📅",
      bgColor: "#f4fff4",
    },
    {
      id: 7,
      title: "Booking #R4402 cancelled by guest.",
      type: "booking",
      status: "read",
      timeAgo: "3d ago",
      action: "Viewed",
      icon: "📅",
      bgColor: "#f4fff4",
    },
  ]);

  const [notificationsReserve, setNotificationsReserve] = useState([
    {
      id: 1,
      title: "New booking confirmed for Deluxe Room 101.",
      type: "booking",
      status: "unread",
      timeAgo: "5m ago",
      action: "Mark Read",
      icon: "📅",
      bgColor: "#fff0f3",
    },
    {
      id: 2,
      title: "Payment gateway connection error: Retrying batch.",
      type: "system",
      status: "unread",
      timeAgo: "1h ago",
      action: "Mark Read",
      icon: "⚠️",
      bgColor: "#fff0f3",
    },
    {
      id: 3,
      title: "Guest has checked in to Economy Room 305.",
      type: "checkin",
      status: "read",
      timeAgo: "2h ago",
      action: "Viewed",
      icon: "📅",
      bgColor: "#f4fff4",
    },
    {
      id: 4,
      title: "CHECKOUT ALERT: Room 104 due in 10 minutes (11:00).",
      type: "alert",
      status: "unread",
      timeAgo: "3h ago",
      action: "Mark Read",
      icon: "🕒",
      bgColor: "#fff7f0",
    },
  ]);
  const {
    setBody,
    statusChangeHandler,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    setCommisionModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: PROMOCODE_LIST,
  });

  const column = [
    {
      head: "Sr. No.",
      accessor: "#",
      component: (item, key) => {
        return <>{key < 9 ? `0${key + 1}` : key + 1}</>
      },
    },
    {
      head: "Coupon Name",
      accessor: "name",
    },
    {
      head: "Coupon Code",
      accessor: "promocode",
    },
    { head: "Discount Type", accessor: "type" },

    {
      head: "Amount",
      accessor: "amount",
      component: (item, key) => {
        return <p className="">{item?.amount || item?.discount}</p>;
      },
    },
    { head: "UsedCount", accessor: "usedCount" },
    {
      head: "Start Date",
      accessor: "startDate",
      component: (item, key) => {
        return (
          <>
            <p>{moment(item.startDate).format("DD-MM-YYYY")}</p>
          </>
        );
      },
    },
    {
      head: "Expire Date",
      accessor: "endDate",
      component: (item, key) => {
        return (
          <>
            <p>{moment(item.endDate).format("MM-DD-YYYY")}</p>
          </>
        );
      },
    },
    {
      head: "Status",
      accessor: "status",
      component: (item, key, arr) => <span>{item?.status}</span>,
    },
    {
      head: "Action",
      accessor: "Action",
      component: (item) => {
        console.log(item, "item");
        return (
          <TableActions
            editUrl={`/promoCode/edit/${item._id}`}
            viewLink={`/promoCode/detail/${item._id}`}
            setDeleteModel={() =>
              setDeleteModel({ show: true, dumpId: item?._id })
            }
          />
        );
      },
    },
  ];

  const tabs = [
    { id: "all", label: "All" },
    { id: "booking", label: "Booking" },
    { id: "maintenance", label: "Maintenance" },
    { id: "system", label: "System" },
  ];

  // const toggleReadStatus = (id) => {
  //   setNotificationsData((prev) =>
  //     prev.map((item) =>
  //       item.id === id
  //         ? {
  //           ...item,
  //           status: item.status === "unread" ? "read" : "unread",
  //           action: item.status === "unread" ? "Viewed" : "Mark Read",
  //         }
  //         : item
  //     )
  //   );
  // };


  const [confirmation, setConfirmation] = useState();
  const handleConfirmation = () => setConfirmation(!confirmation);


  const {
    setBody: setBodyNotificationList,
    body: bodyNotificationList,
    data: notificationListData,
    loader: loaderNotificationList, // ✅ add this
    paginationHandler: paginationHandlerNotificationList,
    // searchHandler,
    total: totalNotificationList,
    refetch
  } = dataHandler({
    api: GET_NOTIFICATION_LIST_API,
    orderBy: "createdAt",
    limit: 10,
    extraBody: {
      type: state.tab
    }
  });

  useEffect(() => {
    setBodyNotificationList((prev) => ({
      ...prev,
      type: state.tab,
      page: 1
    }));

    // Optional: refetch immediately after state change
    // refetch();
  }, [state]);

  const toggleReadStatus = async (id) => {
    try {
      const res = await MARK_NOTIFICATION_AS_READ_API(id);
      // console.log(`MARK_NOTIFICATION_AS_READ_API res`, res)
      if (res?.data?.status === "success") {
        refetch();
        // setNotificationsData((prev) =>
        //   prev.map((item) =>
        //     item._id === id ? { ...item, isRead: true } : item
        //   )
        // );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const markAllAsRead = async () => {
    try {
      const res = await MARK_ALL_NOTIFICATIONS_AS_READ_API();
      // console.log(`MARK_NOTIFICATION_AS_READ_API res`, res)
      if (res?.data?.status === "success") {
        refetch();
        // setNotificationsData((prev) =>
        //   prev.map((item) =>
        //     item._id === id ? { ...item, isRead: true } : item
        //   )
        // );
      }
    } catch (err) {
      console.error(err);
    }
  };


  // MARK_ALL_NOTIFICATIONS_AS_READ_API


  // console.log(`notificationListData`, notificationListData)
  return (
    <>
      {/* <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel((p) => defaultDeleteModelState)}
        confirmHandler={() =>
          deleteHandler(() => DELETE_PROMOCODE({ _id: deleteModel.dumpId }))
        }
      /> */}
      <section className="Notificationsection py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center justify-content-between">
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  Notification List
                </h4>
                <button class="deactivatebtn fw-semibold" onClick={() => markAllAsRead()}>
                  <span className="me-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      data-lucide="check-check"
                      class="lucide lucide-check-check w-4 h-4 mr-1"
                    >
                      <path d="M18 6 7 17l-5-5"></path>
                      <path d="m22 10-7.5 7.5L13 16"></path>
                    </svg>
                  </span>
                  Mark All As Read
                </button>
              </div>
            </Col>
            {/* <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    setBody={setBody}
                    searchHandler={searchHandler}
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>
                <div className="right">
                  <Link
                    to="/promocode/add"
                    className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                    style={{ height: 40, minWidth: 100, fontSize: 12 }}
                  >
                    Send Notification
                  </Link>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col> */}

            <Col lg="12" className="my-2">
              <div className="tab-frame">
                <div className="clearfix">
                  {tabs.map((tab) => (
                    <React.Fragment key={tab.id}>
                      <input
                        type="radio"
                        name="tab"
                        id={tab.id}
                        checked={state.tab === tab.id}
                        onChange={() => setState({ tab: tab.id })}
                      />
                      <label htmlFor={tab.id}>{tab.label}</label>
                    </React.Fragment>
                  ))}
                </div>

                {/* {state.tab == "all" && ( */}
                <div className="comonbg notifiyall  mt-3">
                  {loaderNotificationList ? (
                    <div className="text-center py-5">
                      <Loading />
                    </div>
                  ) : notificationListData && notificationListData.length > 0 ? (
                    notificationListData?.map((item, idx) => {
                      const {
                        _id = null,
                        isRead = false,
                        type = "",
                        title = "",
                        createdAt
                      } = item || {};
                      const action = isRead ? "Viewed" : "Mark Read"
                      return (
                        <div
                          className={`notifyitem d-flex align-items-center justify-content-between px-3 py-2 ${isRead ? "" : "unreadbg"
                            }`}
                          key={_id}
                        >
                          <div className="leftContentWrap d-flex align-items-start gap-3">
                            {/* <span>{item.icon}</span> */}
                            <div className="leftContent">
                              <p className="mb-1">{title}</p>
                              <p
                                className={`m-0 rounded-pill status_common ${!isRead
                                  ? "status_unread"
                                  : isRead
                                    ? "status_read"
                                    : ""
                                  }`}
                              >
                                {type.charAt(0).toUpperCase() +
                                  type.slice(1)}
                              </p>
                            </div>
                          </div>
                          <div className="rightTime d-flex align-items-end flex-column gap-2 justify-content-end">
                            <small>{moment(createdAt).fromNow()}</small>
                            <button
                              className={`${isRead
                                ? "viewedbtn"
                                : "markreadbtn"
                                }`}
                              onClick={() => toggleReadStatus(_id)}
                            >
                              {action}
                            </button>
                          </div>
                        </div>
                      );
                    })) : (
                    <div className="text-center py-4 text-muted">No notifications found</div>
                  )}
                </div>
                {/* )} */}

                {/* {state.tab == "booking" && (
                  <div className="comonbg notireservation  mt-3">
                    {notificationsReserve.map((item, idx) => {
                      return (
                        <div
                          className={`notifyitem d-flex align-items-center justify-content-between px-3 py-2  ${item.status === "unread" ? "unreadbg" : ""
                            }`}
                          key={idx}
                        >
                          <div className="leftContentWrap d-flex align-items-start gap-3">
                            <span>{item.icon}</span>
                            <div className="leftContent">
                              <p className="mb-1">{item.title}</p>
                              <p
                                className={`m-0 rounded-pill status_common ${item.status === "unread"
                                  ? "status_unread"
                                  : item.status === "read"
                                    ? "status_read"
                                    : ""
                                  }`}
                              >
                                {item.status.charAt(0).toUpperCase() +
                                  item.status.slice(1)}
                              </p>
                            </div>
                          </div>
                          <div className="rightTime d-flex align-items-end flex-column gap-2 justify-content-end">
                            <small>{item.timeAgo}</small>
                            <button
                              className={`${item.action === "Viewed"
                                ? "viewedbtn"
                                : "markreadbtn"
                                }`}
                              onClick={() => toggleReadStatus(item.id)}
                            >
                              {item.action}
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {state.tab == "tab3" && (
                  <div className="comonbg systemalert  mt-3"></div>
                )} */}
              </div>
            </Col>
            {!loaderNotificationList && (
            <Col lg="12" className="my-2">
              {/* <TableLayout column={column} data={data} loader={loader} /> */}
              <CustomPagination
                total={totalNotificationList}
                pageChangeHandler={paginationHandlerNotificationList}
                body={bodyNotificationList}
                setBody={setBodyNotificationList}
              />
            </Col>)}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Notification;
